import React from "react";
import { observer } from 'mobx-react';


const TimesheetTable = ({ ...props }) => {
    if (props.timesheets && props.timesheets.length > 0) {
        return (
            <table class="table-hover">
                <thead>
                    <tr>
                        <th style={{borderBottom: 0}}></th>
                        <th scope="col">Pay Period End</th>
                        <th scope="col">Date Submitted</th>
                        <th scope="col">Date Certified</th>
                        <th scope="col">Balance (at date)</th>
                        <th scope="col">Total Hours</th>
                        <th scope="col">Pay Rate</th>
                    </tr>
                </thead>
                <tbody>
                    {props.timesheets.map((timesheet) =>
                        <tr key={"timesheet-" + timesheet.id} >
                            <td style={{width: "10%"}}>
                                {(timesheet.isCertified) ?
                                    <button value={timesheet.id} className="btn btn-light" onClick={props.editTimesheet}>View</button>
                                    :
                                    <button value={timesheet.id} className="btn btn-primary" onClick={props.editTimesheet}>Edit</button>
                                }
                            </td>
                            <td>{timesheet.weekEndDateObject.format("l")}</td>
                            <td>{timesheet.dateSubmittedObject.format("l")}</td>
                            <td>{timesheet.isCertified ? timesheet.dateCertifiedObject.format("l") : "N/A"}</td>
                            <td>${timesheet.balanceAtDate.toFixed(2)}</td>
                            <td>{timesheet.totalHours.toFixed(1)}</td>
                            <td>${timesheet.payRate.toFixed(2)}</td>
                        </tr>
                    )}
            </tbody>
            </table>
        );
    }
    else {
        return (
            <div key="timesheet-none" className="well">
                Please select a student above to find timesheets.
            </div>
        )
    }
};

export default observer(TimesheetTable);